var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 20.75A.75.75 0 015.5 20V5.5a1 1 0 011-1h6.276a1 1 0 01.98.804l.08.392a1 1 0 00.98.804H18.5a1 1 0 011 1v7a1 1 0 01-1 1h-4.276a1 1 0 01-.98-.804l-.08-.392a1 1 0 00-.98-.804H8a1 1 0 00-1 1V20a.75.75 0 01-.75.75z",
    fill: "currentColor"
  })));
}
SvgFlagFilled.displayName = 'FlagFilled';
export default SvgFlagFilled;